"use strict";
import ObjectWithIDStore from "./object_with_id_store";
export default new ObjectWithIDStore(
  "BrokeredCarrierTerms"
);
